// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1TRta","amount":"Amount_amount__3hH3K","tip":"Amount_tip__3-7UE","tipHeader":"Amount_tipHeader__Zs7Mu","tipsWrap":"Amount_tipsWrap__1oRAs"};